//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';

export default {
  props: {
    defaultCityOption: String,
    defaultPropertyOption: String,
  },
  data() {
    return {
      selectedCity: "",
      selectedProperty: ""
    };
  },
  computed: {
    ...mapState(['cityOptions', 'propertyOptions']),   
      isSearchEnabled() {
          return !!this.selectedCity;
      },
      filteredProperties() {
          if (this.selectedCity) {
            return this.propertyOptions.filter(property => property.city === this.selectedCity);
          }
          return this.propertyOptions;
      },
      filteredCities() {
          if (!!this.selectedProperty) {
              return this.cityOptions;
          }
          return this.cityOptions.filter(city => city === this.selectedCity);
      }
  },
  methods: {
    ...mapActions(['fetchDropdownOptions', 'submitForm', 'clearForm']),
    async handleSubmit() {
      await this.submitForm({
        city: this.selectedCity,
        property: this.selectedProperty
      });
    },
    handleClear() {    
      this.selectedCity = "";
      this.selectedProperty = "";
      this.clearForm();
    },
    handleCityChange(event) {
      const selectedCity = event.target.value;

      if (this.selectedCity !== selectedCity) {
          this.selectedCity = selectedCity;
      }
      
      this.selectedProperty = "";
    },
    handlePropertyChange(event) {
      // Update the selected city based on the selected property
      const selectedProperty = event.target.value;
      
      let selectedItem = this.getCityForProperty(selectedProperty); // Implement this function

      if (this.selectedCity !== selectedItem) {
          this.selectedCity = selectedItem;
      }

    },
    getCityForProperty(property) {
      var prop = this.propertyOptions.find(prop => prop.name === property);
      
      if (prop) {
          return prop.city;
      }
      return "";
    },
  },
  async created() {
      await this.fetchDropdownOptions(); // Wait for fetchDropdownOptions to complete
  }
};
